import { render, staticRenderFns } from "./db-list-page.vue?vue&type=template&id=b295f0aa&"
import script from "./db-list-page.vue?vue&type=script&lang=js&"
export * from "./db-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports